import React from 'react';
import { useLocation, Navigate } from "react-router-dom";

function RedirectWithoutPhp() {
    const location = useLocation();

     // Retirer l'extension .php du chemin
    const newLocation = location.pathname.replace(".php","");

    return <Navigate to={newLocation + location.search} replace />

}
export default RedirectWithoutPhp;
